module.exports = __webpack_public_path__ + "assets/img/slogan-7fb53f65.png";